import React, { Component } from 'react'
import PropTypes from 'prop-types'
import BatchItem from "./BatchItem"

class BatchList extends Component {
    
    render() {
        const { orders, reloadItems, statusBatch, batch, dataType } = this.props

        return orders.map(order => <BatchItem key={order._id} order={order} reloadItems={reloadItems} statusBatch={statusBatch} dataType={dataType} batch={batch}/>)
    }
}

BatchList.propTypes = {
    orders: PropTypes.array.isRequired
}

export default BatchList